import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ImmunizationComponent } from './index';
@NgModule({
    imports: [RouterModule.forChild([
        {
            path: "",
            component: ImmunizationComponent,
        }
    ])],
    exports: [RouterModule]
})
export class ImmunizationRoutingModule {
    constructor() {
        console.log('ImmunizationRoutingModule loaded.');
    }
};


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/immunization/Immunization.routing.ts